import React, {FC} from 'react';
import Head from 'next/head';

export const AppHead: FC = () => {
    return (
        <Head>
            <meta
                nonce={''}
                name={'viewport'}
                content={
                    'initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover, width=device-width, height=device-height'
                }
            />
            <meta content={'yes'} name={'apple-mobile-web-app-capable'} />
            <meta content={'yes'} name={'mobile-web-app-capable'} />
            <meta content={'yes'} name={'apple-touch-fullscreen'} />

            {/* favicons */}
            <link href={'/favicon/apple-touch-icon.png'} rel={'apple-touch-icon'} sizes={'180x180'} />
            <link href={'/favicon/favicon-48x48.ico'} rel={'shortcut icon'} sizes={'48x48'} type={'image/x-icon'} />
            <link href={'/favicon/favicon.ico'} rel={'shortcut icon'} sizes={'48x48'} type={'image/x-icon'} />
            <link href={'/favicon/favicon-32x32.png'} rel={'icon'} sizes={'32x32'} type={'image/png'} />
            <link href={'/favicon/favicon.png'} rel={'icon'} sizes={'32x32'} type={'image/png'} />
            <link href={'/favicon/favicon-16x16.png'} rel={'icon'} sizes={'16x16'} type={'image/png'} />
            <link color={'#a02842'} href={'/favicon/safari-pinned-tab.svg'} rel={'mask-icon'} />
            <meta content={'/favicon/mstile-144x144.png'} name={'msapplication-TileImage'} />
            <meta content={'#2b5797'} name={'msapplication-TileColor'} />

            <link href={'/manifest.json'} rel={'manifest'} />

            {/* SEO и т.п. */}
            <meta content={'index, follow'} name={'robots'} />
            <meta name={'GPTBot'} content={'index'} />
            <meta name={'google'} content={'notranslate'} />
            <meta httpEquiv={'Content-Type'} content={'text/html; charset=UTF-8'} />
            <meta charSet={'utf-8'} />
            <meta httpEquiv={'cleartype'} content={'on'} />

            {/* преконнект */}
            <link nonce={''} rel={'preconnect'} href={'//static.simplewine.ru'} />

            {/* подключение скриптов Gravity Field */}
            <link nonce={''} rel={'preconnect'} href={'//cdn-01.gravityfield.ai'} />
            <link nonce={''} rel={'preconnect'} href={'//evs-01.gravityfield.ai'} />
            <link nonce={''} rel={'dns-prefetch'} href={'//cdn-01.gravityfield.ai'} />
            <link nonce={''} rel={'dns-prefetch'} href={'//evs-01.gravityfield.ai'} />

            <link
                nonce={''}
                as={'font'}
                crossOrigin={'anonymous'}
                href={'/fonts/geometria-regular.woff2'}
                rel={'preload'}
                type={'font/woff2'}
                // @ts-expect-error
                fetchpriority={'high'}
            />
            <link
                nonce={''}
                as={'font'}
                crossOrigin={'anonymous'}
                href={'/fonts/geometria-medium.woff2'}
                rel={'preload'}
                type={'font/woff2'}
                // @ts-expect-error
                fetchpriority={'high'}
            />
            <link
                nonce={''}
                as={'font'}
                crossOrigin={'anonymous'}
                href={'/fonts/geometria-bold.woff2'}
                rel={'preload'}
                type={'font/woff2'}
                // @ts-expect-error
                fetchpriority={'high'}
            />
            <link
                nonce={''}
                as={'font'}
                crossOrigin={'anonymous'}
                href={'/fonts/charterITC-bold.woff'}
                rel={'preload'}
                type={'font/woff'}
                // @ts-expect-error
                fetchpriority={'high'}
            />
            <link
                nonce={''}
                as={'font'}
                crossOrigin={'anonymous'}
                href={'/fonts/charterITC-italic.woff'}
                rel={'preload'}
                type={'font/woff'}
                // @ts-expect-error
                fetchpriority={'high'}
            />
            <link
                nonce={''}
                as={'font'}
                crossOrigin={'anonymous'}
                href={'/fonts/charterITC-regular.woff'}
                rel={'preload'}
                type={'font/woff'}
                // @ts-expect-error
                fetchpriority={'high'}
            />
        </Head>
    );
};
